const Cancel =()=> {

	return (
            <h1>Cancelled</h1>
	)

}

export default Cancel;
